<template>
  <v-container fluid>
    <v-row>
      <v-col cols="10" md="12" lg="12" xl="12">
      <v-card>
          <v-card-title>
             <h3>Gerenciar faturas</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col :cols="6">
                <v-autocomplete
                    :items="tiposStatus"
                    v-model="statusSelecionado"
                    item-text="Status"
                    item-value="idSituacao"
                    label="Filtrar por situação"
                    @change="getFaturamentos($event)"
                    hide-details
                    outlined
                    dense
                    clearable
                ></v-autocomplete>
              </v-col>
              <v-col :cols="6">
                <v-autocomplete
                    :items="unidadesList"
                    v-model="unidadeSelecionada"
                    item-text="Unidade"
                    item-value="IdUnidade"
                    label="Unidade"
                    @change="[getFaturamentos($event)]"
                    hide-details
                    outlined
                    dense
                    clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                  <v-text-field v-model="search" prepend-icon="mdi-feature-search-outline" label="Pesquisar" clearable></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :items="faturamentos"
              :headers="headers"
              :search="search"
              :loading="loadFatura"
              :expanded.sync="expanded"
              show-expand
              single-expand
              item-key="IdFatura"
              loading-text="Carregando..."
              class="elevation-1">

              <template v-slot:[`item.IdFatura`]=" { item } ">
                  {{item.FaturaNumero}}/{{item.FaturaAno}}
              </template>
              <template v-slot:[`item.ValorFaturado`]=" { item } ">
                  {{ item.ValorFaturado | numeral('$ 0,0.00') }}
              </template>
              <template v-slot:[`item.ValorPago`]=" { item } ">
                <v-chip
                  v-if="item.cobrancas[0].IdStatus === 2"
                  color="red" dark>
                  {{ item.ValorPago | numeral('$ 0,0.00') }}
                </v-chip>
                <v-chip
                  v-else-if="item.ValorPago === 0"
                  color="#ADD8E6">
                  {{ item.ValorPago | numeral('$ 0,0.00') }}
                </v-chip>
                <v-chip
                  v-else-if="item.ValorPago == item.ValorFaturado"
                  color="green" dark>
                  {{ item.ValorPago | numeral('$ 0,0.00') }}
                </v-chip>
                <v-chip
                  v-else
                  color="primary">
                  {{ item.ValorPago | numeral('$ 0,0.00') }}
                </v-chip>
              </template>
              <template v-slot:[`item.chip`]=" { item } ">
                  <v-chip
                    v-if="item.cobrancas[0].IdStatus === 2"
                    color="red" dark>
                    Cancelada
                  </v-chip>
                  <v-chip
                    v-else-if="item.ValorPago === 0"
                    color="#ADD8E6">
                    Em aberto
                  </v-chip>
                  <v-chip
                    v-else-if="item.ValorPago == item.ValorFaturado"
                    color="green" dark>
                    Liquidado
                  </v-chip>
                  <v-chip
                    v-else
                    color="primary">
                    Parcialmente paga
                  </v-chip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :disabled="verifyRulesEnableButton(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="red"
                        icon
                        @click="[ modalObservacao = !modalObservacao, setDataObservacao(item), ]"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar fatura</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :disabled="verifyRulesEnableButton(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        icon
                        @click="[notifyEmailFaturamento(item)]"
                        >
                      <v-icon>mdi-email</v-icon>
                    </v-btn>
                  </template>
                  <span>Enviar notificação por email</span>
                </v-tooltip>
              </template>

              <template v-slot:expanded-item="{ item }">
                <td colspan="12" style="padding: 10px">
                  <v-data-table
                    :loading="loadFatura"
                    :headers="headersCobrancas"
                    :items="item.cobrancas"
                    class="elevation-0"
                    hide-default-footer
                    disable-pagination
                  >
                  <template v-slot:[`item.DataVencimento`]=" { item } ">
                    {{ $moment(item.DataVencimento).format('L') }}
                  </template>
                  <template v-slot:[`item.Valor`]=" { item } ">
                      {{ item.Valor | numeral('$ 0,0.00') }}
                  </template>
                  <template v-slot:[`item.ValorPago`]=" { item } ">
                      {{ item.ValorPago | numeral('$ 0,0.00') }}
                  </template>
                  <template v-slot:[`item.DataPagamento`]=" { item } ">
                    {{ item.DataPagamento ? $moment(item.DataPagamento).format('L') : '' }}
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :disabled="verifyRulesRegistrarPagamento(item)"
                          v-bind="attrs"
                          v-on="on"
                          color="green"
                          icon
                          @click="[zerarCampos(),getFormasPagamento(), getParcela(item.IdFatura, item.Parcela), system.modalRegistrarBaixa = true]"
                        >
                          <v-icon>mdi-cash-fast</v-icon>
                        </v-btn>
                      </template>
                      <span>Registrar pagamento</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          v-if="item.boleto"
                          color="orange"
                          icon
                          ref="copy"
                          @click="[viewBoleto(item.boleto.numero_titulo_cliente, item.IdFatura)]"
                        >
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizar boleto</span>
                    </v-tooltip>
                  </template>

                  </v-data-table>
                </td>
              </template>

            </v-data-table>
          </v-card-text>
      </v-card>
      </v-col>
    </v-row>
      <v-dialog width="40%" v-model="system.modalRegistrarBaixa">
          <v-card>
              <v-card-title>Registrar pagamento para a fatura {{ faturaunica.IdFatura }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                  <v-row>
                      <v-col cols="6">
                          <v-menu
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ }">
                                <v-autocomplete
                                    :items="tiposPagamento"
                                    v-model="faturaunica.IdFormaPagamento"
                                    item-text="FormaPagamento"
                                    item-value="IdFormaPagamento"
                                    label="Forma de Pagamento*"
                                    hide-details
                                    outlined
                                    dense
                                ></v-autocomplete>
                              </template>
                          </v-menu>
                      </v-col>
                      <v-col cols="6">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                          <template v-slot:activator="{ }">
                            <v-select
                                :items="faturaunica.parcela"
                                v-model="faturaunica.parcela"
                                item-text="Parcela"
                                item-value="IdSequencial"
                                label="Parcelas da Fatura*"
                                hide-details
                                outlined
                                dense
                            ></v-select>
                          </template>
                        </v-menu>
                    </v-col>
                      <v-col cols="6">
                          <v-menu
                              v-model="anexoFormaPagamento"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ }">
                                <v-file-input
                                    small-chips
                                    show-size
                                    multiple
                                    label="Anexo*"
                                    ref="files"
                                    v-model="files"
                                ></v-file-input>
                              </template>
                          </v-menu>
                      </v-col>
                    <v-col cols="6">
                      <v-menu
                          v-model="MenuDataPagamento"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="dataPagamento"
                              label="Data Pagamento"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              type="date"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dataPagamento"
                            @input="MenuDataPagamento"

                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12">
                      <v-menu
                          v-model="Observacao"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                      >
                        <template v-slot:activator="{ }">
                          <v-row>
                            <v-icon>mdi-text</v-icon>
                            <v-text-field
                                v-model="observacaoPagamento"
                                label="Adicionar observação (opcional)"
                            ></v-text-field>
                          </v-row>
                        </template>
                      </v-menu>
                    </v-col>
                    <v-row>
                      <v-col cols="12">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                          <template v-slot:activator="{ }">
                            {{faturaunica.parcela}}ª parcela da fatura. Valor: R$ {{faturaunica.valor}}.
                            Vencimento: {{new Date(faturaunica.vencimento).toLocaleDateString()}}
                          </template>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-row>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                <v-btn
                    @click="
            [
              (system.modalRegistrarBaixa = !system.modalRegistrarBaixa),
              zerarCampos(),
            ]
          "
                    large
                    dark
                >
                  Cancelar
                </v-btn>
                <v-btn
                    :loading="loadingBtnRegistrarBaixa"
                    :disabled="verifyRulesEnableButtonRegistrar()"
                    @click="registrarbaixa()"
                    color="primary"
                    large
                >Registrar
                </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>

      <v-dialog width="40%" v-model="modalObservacao">
          <v-card>
              <v-card-title> Observação de cancelamento da fatura {{ this.faturaNumeroModal }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-text-field
                    v-model="observacaoText"
                    label="Observacao de cancelamento"
                    :rules="[rules.required]"
                    clearable
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn
                      @click="[ modalObservacao = !modalObservacao, nullFields() ]"
                      large
                      dark
                    >
                      Cancelar
                </v-btn>
                <v-btn
                    :loading="loadingBtnRegistrarBaixa"
                    :disabled="!observacaoText"
                    @click="cancelFatura()"
                    color="primary"
                    large
                  >
                    Registrar
                </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>

    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </v-container>
</template>

<script>
import AlertSystem from "../components/AlertSystem.vue";

// @ is an alias to /src
export default {
name: 'Faturamento',
components: {
  AlertSystem,
},
data: () => ({
  headers: [
      { text: "", value: "data-table-expand" },
      { text: "Fatura", value: "IdFatura", width: "5%" },
      { text: "CNPJ", value: "empresa.CNPJ", width: "10%" },
      { text: "Razão social", value: "empresa.RazaoSocial", width: "25%" },
      { text: "Contrato", value: "contrato.NumeroContrato", width: "10%" },
      { text: "Unidade", value: "unidade.Sigla", width: "10%" },
      { text: "Nota fiscal", value: "NotaFiscalNumero", width: "10%" },
      { text: "Valor faturado", value: "ValorFaturado", width: "12%" },
      { text: "Valor pago", value: "ValorPago", width: "12%" },
      { text: "Situação", value: "chip", width: "10%" },
      { text: "Ações", value: "actions", align: "right", width: "8%" }
  ],
  headersCobrancas: [
    { text: "Parcela", value: "Parcela" },
    { text: "Valor parcela", value: "Valor" },
    { text: "Data vencimento", value: "DataVencimento" },
    { text: "Forma de cobrança", value: "formacobranca.FormaPagamento" },
    { text: "Valor pago", value: "ValorPago" },
    { text: "Data pagamento", value: "DataPagamento" },
    { text: "Forma de pagamento", value: "formapagamento.FormaPagamento" },
    { text: "Ações", value: "actions", align: "right", width: "8%" }
  ],
  system:{
    snackbar: {},
    modalRegistrarBaixa: false,
  },
  faturamentos: [],
  statusSelecionado: null,
  tiposStatus:[
    {
      idSituacao: 0,
      Status: 'Faturas abertas'
    },
    {
      idSituacao: 1,
      Status: 'Faturas pagas'
    },
    {
      idSituacao: 2,
      Status: 'Faturas canceladas'
    },
  ],
  rules: {
    required: value => !!value || 'Campo obrigatório',
  },
  expanded: [],
  modalObservacao: false,
  observacaoText: '',
  idFatura: null,
  faturaNumeroModal: '',
  loadingBtnRegistrarBaixa: false,
  MenuDataPagamento: false,
  tiposPagamento: [],
  search: '',
  status: 1,
  url: "",
  dynamicCol: 6,
  loadFatura: false,
  dataPagamento:null,
  myloadingvariable: false,
  unidadesList: [],
  unidadeSelecionada:null,
  anexoFormaPagamento:null,
  faturaunica:{
    idFatura: null,
    idParcela: null,
    valor:null,
    parcela:null,
    vencimento:null,
    IdFormaPagamento:null,
    idFaturaCobranca: null
  },
  observacaoPagamento:null,
  Observacao:null,
  files: [],
  snackbar: false,
}),
methods: {
  setDataObservacao(item) {
    this.faturaNumeroModal = item.FaturaNumero +"/"+ item.FaturaAno;
    this.idFatura = item.IdFatura
  },
  nullFields() {
    this.observacaoText = null;
  },
  getUnidades() {
      this.loadFatura = false;
    this.axios('unidades').then(res => {
      this.unidadesList = res.data
    })
  },
  getFaturamentos () {
      this.loadFatura = true;
      this.axios.get('/faturamentos', {
        params:{
          IdUnidade: this.unidadeSelecionada,
          IdStatus: this.statusSelecionado
        }
      }).then( res => {
          this.faturamentos = res.data
      }).finally(() => {
        this.loadFatura = false;
      })
  },
  cancelFatura(){
      this.loadFatura = true
      this.axios.patch(`boleto/cancel/${this.idFatura}`, {
        observacao: this.observacaoText,
      }).then((res) => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
      }).catch((error) => {
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      }).finally(() => {
        this.modalObservacao = !this.modalObservacao;
        this.loadFatura = false;
        this.getFaturamentos();
      });
  },
  notifyEmailFaturamento(item){
    let con = confirm("Deseja renotificar a empresa sobre a fatura " + item.FaturaNumero + "/" + item.FaturaAno + "?")
    if (con) {
      this.loadFatura = true
      this.axios.post(`faturamentos/${item.IdFatura}/notify/${item.IdEmpresa}`, {
        fatura: item,
      }).then((res) => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data.message,
          color: "green",
        };
      }).catch((error) => {
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      }).finally(() => {
        this.loadFatura = false;
      });
    }
  },
  viewBoleto(numero_titulo_cliente, idFatura) {
    this.loadFatura = true
    this.axios({
      url: 'boleto/viewBoleto',
      method: 'GET',
      responseType: 'blob',
      params: {
        IdFatura: idFatura,
        NossoNumero: numero_titulo_cliente
      }
    })
    .then(res => {
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    })
    .finally(() => {
      this.loadFatura = false
    })
    .catch(async error => {
        const text = await error.response.data.text();
        const errorMessage = JSON.parse(text);
        this.system.snackbar = {
          snackbar: true,
          text: errorMessage,
          color: "red",
        };
    });
  },

  registrarbaixa() {
      this.loadingBtnRegistrarBaixa = true

      let formData = new FormData();
      formData.append('files', this.files == null ? "" : this.files[0]),
      formData.append('FaturaId', this.faturaunica.idFatura),
      formData.append('IdFaturaCobranca', this.faturaunica.idFaturaCobranca),
      formData.append('numeroParcela', this.faturaunica.parcela),
      formData.append('TipoPagamento', this.faturaunica.IdFormaPagamento),
      formData.append('Observacao', this.observacaoPagamento),
      formData.append('DataPagamento', this.dataPagamento),
      formData.append('Valor', this.faturaunica.valor),
      formData.append('_method', "POST"),

      this.axios.post(`/faturamentos/registrarBaixa`, formData, {
          headers: {'Content-Type': 'multipart/form-data'}
        }
      ).then( res => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
        this.system.modalRegistrarBaixa = false;
        this.getFaturamentos();
      }).finally(() => {
        this.loadingBtnRegistrarBaixa = false;
      })

      .catch(e => {
        this.system.snackbar = {
          snackbar: true,
          text: e.response.data,
          color: "red",
        };
      })
    // }
  },
    getParcela(IdFatura, Parcela){
      this.axios.get(`/faturamentos/${IdFatura}/${Parcela}`)
          .then( res => {
            res.data.map((elem) => {
              this.faturaunicageral = res.data
              this.faturaunica.idFatura = elem.IdFatura
              this.faturaunica.idFaturaCobranca = elem.IdSequencial
              this.faturaunica.idParcela = elem.IdSequencial
              this.faturaunica.valor = elem.Valor
              this.faturaunica.parcela = elem.Parcela
              this.faturaunica.vencimento = elem.DataVencimento
              this.faturaunica.IdFormaPagamento = elem.IdFormaPagamento
            });
          }).finally(() => {
          });
    },
  limparFiltros(){
    this.search = null
    this.unidadeSelecionada = null
    this.getFaturamentos();
    this.dynamicCol = 6
  },
  verifyRulesEnableButtonRegistrar(){
    if(this.faturaunica.IdFormaPagamento == null || this.files.length == 0 || this.faturaunica.parcela == null || this.dataPagamento == null){
        return true
      }else{
        return false
      }
  },
  verifyRulesEnableButton(item) {
      // Verifica as condições e retorna true se o botão deve estar desabilitado
      return item.ValorPago > 0 || item.cobrancas[0].IdStatus === 2;
  },
  verifyRulesRegistrarPagamento(item) {
      if(item.valorPago === item.Valor || item.IdStatus === 2 ||  item.IdStatus === 1){
        return true
      }else{
        return false
      }
  },
  zerarCampos(){
    this.files = [];
    this.faturaunica.IdFormaPagamento = null;
    this.observacaoPagamento = null;
    this.faturaunica.parcela = null;
    this.dataPagamento = null;
    this.faturaunica.valor = null;
  },
  getFormasPagamento(){
    this.axios.get('/faturamentos/formasPagamento')
      .then( res => {
        this.tiposPagamento = res.data
      })
  }
},
mounted() {
    this.getFaturamentos()
    this.getUnidades()
}
}
</script>
